"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const base_measure_component_1 = require("../base_measure.component");
const material_1 = require("@angular/material");
const router_1 = require("@angular/router");
const map_service_1 = require("../../../../../commons/map.service");
const map_component_1 = require("../../../map.component");
const measurement_helper_service_1 = require("../../../../../service/measurement-helper.service");
const entity_helper_service_1 = require("../../../../../service/entity-helper.service");
const application_events_service_1 = require("../../../../../xs/services/events/application-events.service");
const epsg_helper_service_1 = require("../../../../../service/epsg-helper.service");
const file_manager_service_1 = require("@src/app/service/file-manager.service");
const Cesium = window.Cesium;
class AreaComponent extends base_measure_component_1.BaseMeasure {
    constructor(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager) {
        super(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager);
        this.route = route;
        this.router = router;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.mappingHelper = mappingHelper;
        this.entityHelper = entityHelper;
        this.applicationEvents = applicationEvents;
        this.epsgHelper = epsgHelper;
        this.fileManager = fileManager;
        // yes, we can calculate area
        this.canCalculate = true;
        this.autoCalculate = true;
    }
    ngOnInit() {
        if (this.mapService.scene) {
            this.init();
        }
        else {
            this.addSubscription('area-sceneChange', this.mapService.onSceneChange('area.component').subscribe(_ => {
                this.init();
            }));
        }
    }
    init() {
        super.onInit();
    }
    ngOnDestroy() {
        super.onDestroy();
    }
    calculate() {
        // console.log ( '  ----- AREA CALCULATE ------' );
        if (this.shapeMaker.selectedShape == null)
            return;
        // console.log ( '  ----- AREA CALCULATE ------' );
        let points = this.shapes[this.shapeMaker.selectedShape].points;
        let posis = points.map(p => p.coords);
        if (!this.shapes[this.shapeMaker.selectedShape].calc) {
            this.shapes[this.shapeMaker.selectedShape].calc = {};
        }
        this.shapes[this.shapeMaker.selectedShape].calc['area'] = this.calculateShape(posis);
    }
    calculateShape(vertices) {
        // Compute plane normal by converting to cartographic, increasing height, converting back
        var firstPoint = vertices[0];
        var geoFirstPointElevated = this.mapService.viewer.scene.globe.ellipsoid.cartesianToCartographic(firstPoint);
        geoFirstPointElevated.height += 100;
        var firstPointElevated = this.mapService.viewer.scene.globe.ellipsoid.cartographicToCartesian(geoFirstPointElevated);
        // and then subtracting from the original point
        var planeNormal = new Cesium.Cartesian3();
        Cesium.Cartesian3.subtract(firstPointElevated, firstPoint, planeNormal);
        Cesium.Cartesian3.normalize(planeNormal, planeNormal);
        var zAxisNormal = new Cesium.Cartesian3(0, 0, 1);
        // Compute the cosine of the angule between the two planes
        var planeAngle = Cesium.Cartesian3.dot(planeNormal, zAxisNormal);
        // Create a axis of rotation using the cross product of the z axis and our plane
        var rotationAxis = new Cesium.Cartesian3();
        Cesium.Cartesian3.cross(planeNormal, zAxisNormal, rotationAxis);
        Cesium.Cartesian3.normalize(rotationAxis, rotationAxis);
        // Create a rotation matrix around the rotation axis and use it to transform points
        var c = planeAngle;
        var s = Math.sqrt(1 - c * c);
        var invc = 1 - c;
        // Iterate over all points, rotate onto xy plane, discard z
        // Find area using progressive determinants of vertices in polygon
        var area = 0, perimeter = 0;
        vertices.forEach((point, index) => {
            // Do not do anything on the last point
            var nextPoint = vertices[index + 1];
            if (index === vertices.length - 1) {
                nextPoint = vertices[0];
            }
            var rotPoint = this.rotate(point, c, s, invc, rotationAxis), rotNextPoint = this.rotate(nextPoint, c, s, invc, rotationAxis);
            area += rotPoint.x * rotNextPoint.y - rotNextPoint.x * rotPoint.y;
            perimeter += Math.sqrt(Math.pow(rotPoint.x - rotNextPoint.x, 2) +
                Math.pow(rotPoint.y - rotNextPoint.y, 2));
        });
        return Math.abs(area / 2);
    }
    // Rotate onto plane defined by c, s, invc angles
    rotate(point, c, s, invc, rotationAxis) {
        var x = rotationAxis.x, y = rotationAxis.y, z = rotationAxis.z, px = point.x, py = point.y, pz = point.z;
        // Dot product of a given point and rotation matrix around rotationAxis
        return new Cesium.Cartesian3(px * (x * x * invc + c) + py * (x * y * invc - z * s) + pz * (x * z * invc + y * s), px * (y * x * invc + z * s) + py * (y * y * invc + c) + pz * (y * z * invc - x * s), px * (z * x * invc - y * s) + py * (z * y * invc + x * s) + pz * (z * z * invc + c));
    }
}
exports.AreaComponent = AreaComponent;
